import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/rc-checkbox/es/index.js
// module id = 204
// module chunks = 0